'use strict';
var util = require('../util');

var apis = ['alert', 'confirm', 'actionSheet', 'prompt', 'setPullDown', 'stopPullDown', 'downloadImage'];
var core = {
    appVersion: '7.8.0'
};

apis.forEach(function(api) {
    var fn = util.actionMapping(api);
    core[api] = fn;
});
core.prompt = function(opt) {
    if (!opt.placeholder) {
        opt.placeholder = '';
    }
    if (util.osName === 'ios') {
        // FIX: message参数有bug，暂时不加入filterList
        var filterList = ['title', 'placeholder', 'okButton', 'cancelButton', 'success', 'fail'];
        var optKeys = Object.keys(opt);
        for (var i = 0; i < optKeys.length; i++) {
            var key = optKeys[i];
            if (!~filterList.indexOf(key)) {
                delete opt[key];
            }
        }
    }
    this._send('prompt', opt);
};

module.exports = core;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/patch/patch-7.8.0.js
// module id = 523
// module chunks = 0